import React from 'react';
import { StyleSheet, View } from './components/base_components';
import ProgressSpinner from './components/progress_spinner';
import Breadcrumb from './components/breadcrumb';
import StandardBoxList from './components/standard_box_list';
import TabBar from './components/tab_bar';
import TitleActionLine from './components/title_action_line';

import MediaGrantAdminStore from './stores/media_grant_admin_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  volumeListGrantScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  tabBar: {
    marginLeft: '2rem',
    marginRight: '2rem',
  },
});

export default function VolumeListGrantScreen() {
  const org = UserStore.useOrg();
  const list = MediaGrantAdminStore.useList(org?.org_id);

  React.useEffect(() => {
    MediaGrantAdminStore.fetch(org?.org_id);
  }, [org?.org_id]);

  return (
    <View style={styles.volumeListGrantScreen}>
      <Breadcrumb list={[{ text: 'Volumes', url: '/volume' }, 'Permissions']} />
      <TitleActionLine title='Permissions' />
      <TabBar
        style={styles.tabBar}
        list={[
          { text: 'Volumes', value: 'volume', url: '/volume' },
          { text: 'Permissions', value: 'grant', url: '/volume/permission' },
        ]}
      />
      <StandardBoxList
        title='Containers'
        detail={list?.length}
        headers={['Container Name', 'Volume Name', 'Prefix Path', 'Status']}
        sizes={[2, 2, 2]}
        rows={list?.map?.((grant: any) => ({
          url: `/volume/${grant?.volume_id}/grant/${grant.grant_name}`,
          list: [
            grant.grant_name,
            grant.volume_name,
            grant.prefix_path,
            grant.is_disabled ? 'Disabled' : 'Enabled',
          ],
        }))}
      >
        {list ? null : <ProgressSpinner />}
      </StandardBoxList>
    </View>
  );
}
